import React from 'react';
import {
  Navigate,
} from 'react-big-calendar';

import {
  Button,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';

type Props = {
  onNavigate: { (): void },
  label: string,
}

export default ({
  onNavigate,
  label,
}: Props) => (
  <Flex
    align="center"
    padding="10px"
    spacing={40}
  >
    <Flex align="center" spacing={8}>
      <Button
        ghost
        circled
        appearance="primary"
        icon="fas fa-chevron-left"
        onClick={() => onNavigate(Navigate.PREVIOUS)}
      />
      <Button
        ghost
        circled
        appearance="primary"
        icon="fas fa-chevron-right"
        onClick={() => onNavigate(Navigate.NEXT)}
      />
    </Flex>
    <Text
      weight={500}
      size="30px"
    >
      {label}
    </Text>
  </Flex>
);
